import { AdminService } from './../../services/admin.service';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import {
  ModalDismissReasons,
  NgbModal,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from 'src/app/config/app.constant';
import { AppStateProvider } from 'src/app/providers/app-state.provider';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  standalone: false,
  selector: 'app-employees-list',
  templateUrl: './employees-list.component.html',
  styleUrls: ['./employees-list.component.scss'],
})
export class EmployeesListComponent implements OnInit {
  @ViewChild('contentActivation', { static: false }) content: ElementRef;
  @ViewChild('contentCreditPoint', { static: false }) content2: ElementRef;


  meetingNav: { index: string; name: string; link: string }[];
  closeResult: string;
  page = 1;
  membersList = [
    {
      index: '0',
      name: 'Rakesh Jha',
      role: 'Analyst',
      contact: '+91 9561088278',
      location: 'SS 03',
      company: 'Robust Technologies Pvt Ltd.',
      selected: false,
      emailid: 'abc@cap.com',
      isResendEmail: true,
      isRevokeInvitation: true,
      isActivation: false,
      isCredit: false,
    },
    {
      index: '1',
      name: 'Rakesh Jha1',
      role: 'Analyst',
      contact: '+91 9561088278',
      location: 'SS 03',
      company: 'Robust Technologies Pvt Ltd.',
      selected: false,
      emailid: 'def@cap.com',
      isResendEmail: true,
      isRevokeInvitation: true,
    },
    {
      index: '2',
      name: 'Rakesh Jha2',
      role: 'Analyst',
      contact: '+91 9561088278',
      location: 'SS 03',
      company: 'Robust Technologies Pvt Ltd.',
      selected: false,
      emailid: 'ghi@cap.com',
      isResendEmail: false,
      isRevokeInvitation: false,
      isActivation: true,
      isCredit: true,
    },
    {
      index: '3',
      name: 'Rakesh Jha3',
      role: 'Analyst',
      contact: '+91 9561088278',
      location: 'SS 03',
      company: 'Robust Technologies Pvt Ltd.',
      selected: false,
      emailid: 'jkl@cap.com',
      isResendEmail: false,
      isRevokeInvitation: false,
      isActivation: true,
      isCredit: true,
    },
    {
      index: '4',
      name: 'Rakesh Jha4',
      role: 'Analyst',
      contact: '+91 9561088278',
      location: 'SS 03',
      company: 'Robust Technologies Pvt Ltd.',
      selected: false,
      emailid: 'mno@cap.com',
      isResendEmail: false,
      isRevokeInvitation: false,
      isActivation: true,
      isCredit: true,
    },
    {
      index: '5',
      name: 'Rakesh Jha5',
      role: 'Analyst',
      contact: '+91 9561088278',
      location: 'SS 03',
      company: 'Robust Technologies Pvt Ltd.',
      selected: false,
      emailid: 'pqr@cap.com',
      isResendEmail: false,
      isRevokeInvitation: false,
      isActivation: true,
      isCredit: true,
    },
    {
      index: '6',
      name: 'Rakesh Jha6',
      role: 'Analyst',
      contact: '+91 9561088278',
      location: 'SS 03',
      company: 'Robust Technologies Pvt Ltd.',
      selected: false,
      emailid: 'stv@cap.com',
      isResendEmail: false,
      isRevokeInvitation: false,
      isActivation: true,
      isCredit: true,
    },
  ];
  @ViewChild('revokeInvitation', { static: false })
  revokeInvitation: NgbModalRef;

  statusText: string;

  priviledge: boolean;
  token: any;
  access_token: any;
  url: any;
  members: any = [];
  officeToken: any;
  deptInfo: any;
  itemsDisplayed;
  searchText = '';
  unregisteredLength: any;
  showLoader = false;
  selectedMemberRevokeInv: any = null;
  pageSize: number = 10;
  member: any;
  showPagination: boolean;
  change: boolean;
  selectedUser: any;
  activation: boolean;
  creditText: string;
  creditUserId: any;
  creditPointAccess: boolean;
  vacantSpace: number;

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private commonService: CommonService,
    private apiService: ApiService,
    private appStateSrv: AppStateProvider,
    private adminSrv: AdminService
  ) { }
  open(content) {
    this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
        windowClass: 'custom-class',
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  ngOnInit(): void {
    this.itemsDisplayed = 10 * this.page;
    this.showLoader = true;
    this.getApiauthorizationToken();
    // this.pagination();

    this.meetingNav = [
      {
        index: '1',
        name: 'Employees',
        link: '/employees/employees-list',
      },
    ];

    const route = {
      index: '1',
      name: 'Employees',
      link: '/employees/employees-list',
    };
    this.appStateSrv.setSideNavState(route);
  }
  getApiauthorizationToken() {
    //this.commonService.getApiauthorizationToken().subscribe((res) => {
    if (localStorage.getItem(AppConstant.localStorage.token) != null) {
      this.getDepartmentDetails();
      this.getauthorizationToken();
    }
    //});
  }
  getauthorizationToken() {
    this.commonService.getauthorizationToken().subscribe((res) => {
      this.access_token = res.access_token;
      this.officeToken = res.access_token;
      if (this.officeToken != null) {
        this.getMembers();
      }
    });
  }
  getMembers() {
    this.url = APIs.getOfficeMembers;
    const paramObj = {
      Authorization: this.officeToken,
    };
    this.apiService.get(this.url, paramObj).subscribe({
      next: (response: any) => {
        this.getAccessPoints();
        // this.showLoader = false;
        // this.members=response;
        // let len =this.members.list.length;
      },
      error: (err) => console.log('error', err)
    });
  }
  getAccessPoints() {
    this.url = APIs.getOfficeAccessPoints;
    const paramObj = {
      Authorization: this.officeToken,
    };
    this.apiService.get(this.url, paramObj).subscribe({
      next: (response: any) => {
        this.getEmployeesList();
        // this.showLoader = false;
        // this.members=response;
        // let len =this.members.list.length;
      },
      error: (err) => console.log('error', err)
    });
  }
  getDepartmentDetails() {
    this.url = APIs.getDepartmentList;
    this.apiService.get(this.url, '').subscribe({
      next: (response: any) => {
        this.deptInfo = response;

        // this.members.list.departmentname=this.deptInfo.data.department
      },
      error: (err) => console.log('error', err)
    });
  }

  generateInitials(name: string) {
    if (name)
      return (
        name.split(' ')[0].charAt(0).toUpperCase() +
        ' ' +
        (name.split(' ')[1] !== undefined
          ? name.split(' ')[1].charAt(0).toUpperCase()
          : '')
      );
    else return '';
  }


  getTenantMoreDetails() {
    this.adminSrv.getTenantMoreDetails().subscribe((response) => {
      console.log('more details ', response);
      this.vacantSpace=response?.vacantSpace
      // this.vacantSpace = response.pax - this.members.list.length < 0 ? 0 : response.pax - this.members.list.length;
    });
  }

  getEmployeesList() {
    this.url = APIs.gettennatEmployeeList;
    const paramobj = {
      TenantId: localStorage.getItem(AppConstant.localStorage.tenantId),
    };
    this.apiService.get(this.url, paramobj).subscribe({
      next: (response: any) => {
        this.members = response;
        this.getTenantMoreDetails();
        this.showLoader = false;
        this.unregisteredLength = this.members.list.filter(
          (item) => item.isRegistered === false
        ).length;
        this.members.list.forEach((element, index) => {
          if (element.departmentId != null) {
            let data = this.deptInfo.list.filter(
              (item) => item.id === element.departmentId
            );
            // element.department=this.deptInfo.data.department;
            this.members.list[index].department = data[0].department;
          }
        });
        this.handlePageChange(1);
      },
      error: (err) => console.log('error', err)
    });
  }
  resendEmail(member) {
    console.log('member', member);

    //this.commonService.getApiauthorizationToken().subscribe((res) => {
    if (localStorage.getItem(AppConstant.localStorage.token) != null) {
      this.url = APIs.resendEmail;
      const param = {
        Id: member.userId,
      };

      this.apiService.post(this.url, '', param).subscribe({
        next: (response: any) => { },
        error: (err) => console.log('error', err)
      });
    }
    //});
  }
  revokeAccess() {
    const data = {
      id: this.selectedMemberRevokeInv.userId,
      tenantId: localStorage.getItem(AppConstant.localStorage.tenantId)
    };
    this.apiService.post(APIs.revokeAccess, data).subscribe(
      (result) => {
        console.log('result', result);
        this.selectedMemberRevokeInv = null;
        this.modalService.dismissAll();
        this.showLoader = true;
        // this.getMembers();
        window.location.reload();
      },
      (error) => { }
    );
    // this.open(this.content);
  }

  onCancel(module) {

    if (module == 'activation') {
      this.activation = !this.activation;
    }
    if (module == 'privilege') {
      this.priviledge = !this.priviledge;
    } else {
    }
    window.location.reload();
  }

  openRevoke(member) {
    this.selectedMemberRevokeInv = member;
    this.open(this.revokeInvitation);
  }
  addEmployee() {
    this.router.navigate(['/employees/employees-list/add-employees']);
  }

  togglePriviledgeSelection(show, user) {
    console.log('show', show, 'user', user);
    this.creditUserId = user.userId;
    this.creditPointAccess = !user.isCreditPointAccess
    this.priviledge = !user.isCreditPointAccess
    this.creditText = this.priviledge ? 'Activate' : 'De-Activate';
    this.open(this.content2);
  }

  changeCreditStatus() {

    if (this.creditUserId && this.creditUserId !== undefined) {
      this.url = '';
      this.url = APIs.updateUserCreditAccess;
      this.url =
        this.url + '?id=' + this.creditUserId + '&isCreditPointAccess=' + this.creditPointAccess;
      const paramObj = {
        userId: this.creditUserId,
      };
      this.apiService.put(this.url, '', null).subscribe(
        (response) => {
          if (response.isValid && response.successMsg) {
            // this.getMembers();
            window.location.reload();
            this.modalService.dismissAll();
          } else {
            //handle error values here. check for 'errorMsg'
            // alert('here' + response.errorMsg);
          }
        },
        (error) => {
          // handle api error here
          // alert(error);
        }
      );
    }
  }

  toggleActivationSelection(show, user) {

    console.log('team', user);
    this.selectedUser = user;
    this.activation = !user.t0200OrgEmployees[0].isActive;
    this.statusText = this.activation ? 'Activate' : 'Deactivate';
    this.open(this.content);
  }

  changeActivation(show, user) {
    //   this.apiService.put(APIs.changeCreditAccess + "?id=" + user.userId + "&isActive=" + !this.activation).subscribe(response => {
    this.adminSrv.changeActivation(!this.selectedUser.t0200OrgEmployees[0].isActive, this.selectedUser.userId).subscribe(response => {
      console.log('response in component', response);
      window.location.reload();
      this.modalService.dismissAll();
    })

  }

  employeeDetails(member) {
    localStorage.setItem(AppConstant.localStorage.selectedMember, member.userId);
    this.router.navigate(['/employees/employees-list/employee-details']);
  }
  bulkUploadEmployees() {
    this.router.navigate(['/employees/employees-list/bulk-upload-employees']);
  }
  handlePageChange(event) {
    this.page = event;
    console.log('pagination clicked');

    this.member = this.members.list.slice(
      0,
      this.members.list.length < 10
        ? this.members.list.length
        : (this.page - 1) * this.pageSize + this.pageSize
    );
    console.log('member', this.member, 'members', this.members);
  }

  // pagination(){
  //   console.log("length",this.members.list)
  //   if( this.members.list.length>9){

  //     this.showPagination=true;
  //     return;
  //   }
  //   this.showPagination=false;
  // }


}
